import React from 'react';
import { render } from 'react-dom';
import { Router, Route, IndexRoute, browserHistory } from 'react-router';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';
import Home from './pages/Home';
import Apply from './pages/Apply';
import Talent from './pages/Talent';
import MobileApp from './pages/MobileApp';
import WebApp from './pages/WebApp';
import Website from './pages/Website';
import GetStarted from './pages/GetStarted';
import Startup from './pages/Startup';
import StartupApply from './pages/StartupApply';
import NotFound from './pages/NotFound';
import './styles/index.css';
import './styles/buttons.css';
import './styles/spacing.css';

const Root = () => (
  <Router onUpdate={() => window.scrollTo(0, 0)} history={browserHistory}>
    <Route path="/" component={App}>
      <IndexRoute component={Home}/>
      <Route path="/apply" component={Apply} />
      <Route path="/talent" component={Talent} />
      <Route path="/mobile-app" component={MobileApp} />
      <Route path="/web-app" component={WebApp} />
      <Route path="/website" component={Website} />
      <Route path="/get-started" component={GetStarted} />
      <Route path="/0-to-startup" component={Startup} />
      <Route path="/startup-application" component={StartupApply} />
      <Route path="*" component={NotFound} />
    </Route>
  </Router>
);

render(
  <Root />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js